export default __webpack_public_path__ + "static/media/conferencing.66855dc1.jpg";